import React from "react";

const ConnectionStatus = ({ isConnected, className, style }) => (
  <div
    className={className}
    style={{
      position: "fixed",
      top: "5px",
      right: "80px",
      padding: "5px 10px",
      borderRadius: "20px",
      background: isConnected ? "rgba(34, 197, 94, 0.15)" : "rgba(239, 68, 68, 0.15)",
      border: "1px solid " + (isConnected ? "rgba(34, 197, 94, 0.3)" : "rgba(239, 68, 68, 0.3)"),
      color: isConnected ? "#22c55e" : "#ef4444",
      fontSize: "11px",
      fontWeight: "600",
      zIndex: 1001,
      display: "flex",
      alignItems: "center",
      gap: "5px",
      pointerEvents: "none",
      userSelect: "none",
      ...style,
    }}
  >
    <div style={{
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: isConnected ? "#22c55e" : "#ef4444",
      flexShrink: 0,
    }} />
    {isConnected ? "Backend Connected" : "Backend Offline"}
  </div>
);

export default ConnectionStatus;
